import React from 'react';
import './Ture.css'

const Ture = () =>{
    
return (
    <div className="Ture">
    
    </div>
  );
};

export default Ture;